import { Component } from '@angular/core';

import { DashboardAlert, DashboardStore } from '../dashboardv2.store';

@Component({
  selector: 'app-dashboard-otr-system-revenue',
  standalone: false,
  templateUrl: './dashboard-otr-system-revenue.component.html',
  styleUrls: [
    '../dashboardv2.component.scss',
    './dashboard-otr-system-revenue.component.scss',
  ],
})
export class DashboardOtrSystemRevenueComponent {

  viewModel$ = this.dashboardStore.otrRevenueViewModel$;

  // Drill-down report params: one row per job with the full set of raw
  // calculator values behind the OTR / Flat Labor / Interstate aggregates.
  // Base is scoped to interstate-owned jobs (the unscoped "View Report" link).
  otrSystemRevenueReportParams$ = this.dashboardStore.getReportQueryParams('otrSystemRevenue');

  triggerReload = this.dashboardStore.triggerReload;

  constructor(
    private readonly dashboardStore: DashboardStore,
  ) {}

  // Requirement: `#6855` - the alert list is rebuilt on every reload, and each alert carries a
  // list of job links. Keyed on the stable alert key so a refresh that leaves an alert unchanged
  // does not tear down and re-create its anchors.
  trackAlert(_index: number, alert: DashboardAlert) {
    return alert.key;
  }

}
